<template>
  <div class="contentBox">
    <navBox :id="navId" :cid="childrenID" ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content" >
      <myHeader ref="myHeader"></myHeader>
      <div class="MobelBox" v-if="addType">
        <p class="add-title">{{addType == 'edit' ? '编辑' : '添加'}}试卷</p>
        <button class="btn btn-hide"  @click="closeSub">关闭</button>
        <div class="step-cont" >
          <div class="model-item">
            <div class="write-txt write-ai">
              <p class="write-title">试卷名称：</p>
              <div class="write-text">
                <input type="text" v-model="addObj.title">
              </div>
            </div>
            <div class="write-txt">
              <p class="write-title"><span>*</span>省市：</p>
              <div class="write-text">
                <el-cascader
                  v-model="cityValue"
                  :options="cityData"
                  @change="handleChange"></el-cascader>
              </div>
            </div>
            <div class="write-txt">
              <p class="write-title"><span>*</span>学段：</p>
              <div class="write-text">
                <el-select placeholder="请选择" v-model="addObj.period">
                  <el-option
                    v-for="item in educationList"
                    :key="item.id"
                    :label="item.title"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="write-txt write-ai">
              <p class="write-title"><span>*</span>上传试卷：</p>
              <div class="write-text">
                <div class="img" @mouseenter="imgShow" @mouseleave="imgHide" v-if="addObj.image">
                  <img :src="'https://pic.speechcoach.cn/'+addObj.image" alt="">
                  <div class="hover" v-if="imgType">
                    <i class="icon-delete" @click="imgRemove"></i>
                  </div>
                </div>
                <el-upload
                  :action="url+'intecl/Exam/importExam'"
                  :headers="{'Usertoken':token}"
                  list-type="picture-card"
                  :before-upload="beforeUploadImg"
                  :on-success="handleSuccessImg"
                  :on-progress="handleProgressImg"
                  :on-remove="handleRemoveImg"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img
                    width="100%"
                    :src="'https://pic.speechcoach.cn/' + addObj.image"
                    alt=""
                  />
                </el-dialog>
              </div>

              <div class="msg-txt">
                <p>
                  <i class="icon icon-msg"></i>
                  上传试卷前需要注意:
                </p>
                <div>
                  <p>1、仅能上传word文档，请提前将试卷保存成word文档 </p>
                  <p>2、试卷中的题干后面必须有分数(若无分数则会导致考情统计错误) <span>例如:1.睛川历历汉阳树，__________。(崔颢《黄鹤楼》(3分) </span></p>
                  <p>3、文档上传成功后AI将进行识别，由于技术限制AI识别结束很可能会导致内容丢失或内容错误，请进行人工校验</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="step-cont" v-loading="loading" :element-loading-text="loadTxt">
          <div class="model-cont">
            <div class="model-item">
              <div class="paper-title">
                <p v-for="(item,index) in paperData" :key="index" :class="paperID==(index+1)?'select':''" @click="topicType(index)">{{item.title?item.title:'无'}}</p>
              </div>
              <div class="write-txt">
                <button class="btn btn-ai" style="display: block;" @click="examChange" v-if="paperDetail">修改板块</button>
                <p class="write-title"><span>*</span>试卷内容</p>
                <span class="ai-msg">以下为AI识别后的内容，可手动修改</span>
                <div class="msg-txt" style="display: inline-block;margin-top: 0;">
                  <i class="icon icon-msg"></i>
                  AI识别可能导致内容丢失或错误，请进行人工校验!
                </div>
              </div>
              
              
            </div>
            <div class="model-item" v-for="(item,index) in paperDetail" :key="index">
                <div class="write-txt">
                  <p class="add-title">题目{{(index+1)}}<span class="btn btn-topic-remove" @click="topicRemove(index)">删除题目</span><button @click="topicAdd(index,'topic')" class="btn btn-ai btn-topic-adds">+添加题目</button></p>
                  <div class="topic-data">
                    <p class="write-title"><span>*</span>素材：</p>
                    <div class="write-text">
                      <!-- <myEditor @input="sourceInput" @imgUpload="imgUpload" :value="addObj.content" :index="index" @click="sourceClick(index)"/> -->
                        <textarea placeholder="请输入素材" v-model="item.content"></textarea>
                    </div>
                  </div>
                  <div v-for="(ele,num) in item.topic" :key="num">
                    <div class="topic-data">
                      <p class="write-title"><span>*</span>题干：</p>
                      <div class="write-text">
                          <textarea placeholder="请输入题干" v-model="ele.topic_title"></textarea>
                      </div>
                      <button class="btn btn-exam-remove" @click="scoreRemove(item,num)">删除题干/答案/分值</button>
                    </div>
                    <div class="topic-data">
                      <p class="write-title"><span>*</span>答案：</p>
                      <div class="write-text">
                          <textarea placeholder="请输入答案" v-model="ele.answer"></textarea>
                      </div>
                    </div>

                    <div class="topic-data" v-if="ele.topic_type==2">
                      <p class="write-title"><span>*</span>选项A：</p>
                      <div class="write-text">
                          <textarea placeholder="请输入文章内容" v-model="ele.option_A"></textarea>
                      </div>
                    </div>
                    <div class="topic-data" v-if="ele.topic_type==2">
                      <p class="write-title"><span>*</span>选项B：</p>
                      <div class="write-text">
                          <textarea placeholder="请输入文章内容" v-model="ele.option_B"></textarea>
                      </div>
                    </div>
                    <div class="topic-data" v-if="ele.topic_type==2">
                      <p class="write-title"><span>*</span>选项C：</p>
                      <div class="write-text">
                          <textarea placeholder="请输入文章内容" v-model="ele.option_C"></textarea>
                      </div>
                    </div>
                    <div class="topic-data" v-if="ele.topic_type==2">
                      <p class="write-title"><span>*</span>选项D：</p>
                      <div class="write-text">
                          <textarea placeholder="请输入文章内容" v-model="ele.option_D"></textarea>
                      </div>
                    </div>

                    <div class="write-txt write-ai">
                      <p class="write-title">分值：</p>
                      <div class="write-text">
                        <input type="text" v-model="ele.topic_score" style="display: inline-block;">
                        <button class="btn btn-ai" @click="topicAdd(num,'score',item)">+添加题干/答案/分值</button>
                      </div>
                    </div>
                    <div class="write-txt write-ai" v-for="(i,k) in ele.exam_sites" :key="k">
                      <p class="write-title">考点名称：{{ele.exam_sites[k]}}</p>
                      <button class="btn btn-ai" @click="aiSub(item,ele,k)">{{ele.exam_sites[k]?'重新识别':'点击进行AI识别'}}</button>
                      <span class="ai-msg">AI识别后可手动修改</span>
                      <div class="write-text">
                        <el-select  placeholder="请选择" v-model="ele.exam_sites[k]" @change="siteChange(ele,num)">
                          <el-option
                            v-for="item in SiteList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.name">
                          </el-option>
                        </el-select>
                      </div>
                      <button class="btn btn-exam-remove" @click="examRemove(ele,k)">删除</button>
                    </div>
                    <button class="btn btn-topic-add" @click="examSitesAdd(ele)">+添加考点</button>
                  </div>
                </div>
            </div>
          </div>
        </div>

        <div class="write-btnBox">
          <button class="btn btn-save" @click="saveSub">确定</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>
      <div class="organiza-txt" v-else>
        <div class="organiza-title clear">
          <div class="organiza-left" @click="addSub">
            <img src="~@/assets/images/icon-add.png" alt="">
            <p>添加试卷</p>
          </div>
          <div class="searchBox clear">
            <div class="search-item">
              <p>试卷名称:</p>
              <input type="text" placeholder="请输入要搜索的试卷名称" v-model="obj.title">
            </div>

            <div class="search-item">
              <p>省市:</p>
              <el-cascader
                  v-model="objCity"
                  :options="cityData"
                  @change="handleChange('obj')"></el-cascader>
            </div>
            
            <div class="search-item">
              <p>学段:</p>
              <el-select v-model="obj.period" filterable placeholder="请选择">
                <el-option
                  v-for="item in educationList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.title">
                </el-option>
              </el-select>
            </div>
           
            <div class="search-btnBox">
              <button class="btn btn-search" @click="searchSub">搜索</button>
              <button class="btn btn-reset" @click="resetSub">重置</button>
            </div>
          </div>
        </div>
        <div class="organiza-list">
          <div class="list-title">原始试卷列表</div>
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.title">{{item.title}}</p>
              <p :title="item.province + '/' + item.city">{{item.province}} / {{item.city}}</p>
              <p :title="item.period==1?'小学':item.period==2?'初中':item.period==3?'高中':''">{{item.period==1?'小学':item.period==2?'初中':item.period==3?'高中':''}}</p>
              <p :title="item.add_time">{{item.add_time}}</p>
              <p>
                <button title="编辑" class="btn btn-revise" @click="buildShow(item)">编辑</button>
                <button title="编辑" class="btn btn-remove" @click="removeShow(item)">删除</button>
              </p>
            </div>
          </div>
          
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>
    </div>

    <div class="msgBox" v-if="removeType">
      <div class="contv">
        <p class="title">是否确定删除？</p>
        <div class="btnBox">
          <button class="btn btn-close" @click="ModelHide('remove')">取消</button>
          <button class="btn btn-sub" @click="removeSub">确定</button>
        </div>
      </div>
    </div>

    <div class="msgBox topicAddBox" v-if="topicBox">
      <div class="contv">
        <p class="title">选择题目类型</p>
        <div class="msg-write">
          <p class="msg-title">题目类型：</p>
          <el-select placeholder="请选择" v-model="topicID">
            <el-option
              v-for="item in topicTypeList"
              :key="item.id"
              :label="item.title"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="btnBox">
          <button class="btn btn-close" @click="ModelHide('topicClose')">取消</button>
          <button class="btn btn-sub" @click="topicTypeSub">确定</button>
        </div>
      </div>
    </div>

    <div class="msgBox topicAddBox examBox" v-if="examType">
      <div class="contv">
        <p class="title">修改板块</p>
        <div class="msg-write" v-for="(item,index) in paperData" :key="index">
          <p class="msg-title">板块{{(index+1)}}：</p>
          <el-select placeholder="请选择" v-model="item.title" @change="examRevise(index)">
            <el-option
              v-for="item in examList"
              :key="item.id"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
          <button class="btn btn-ai" @click="examAdd">添加</button>
          <button class="btn btn-ai" @click="examDel(index)" style="background-color: #E2231A;">删除</button>
        </div>
        <div class="btnBox">
          <button class="btn btn-close" @click="ModelHide('topicClose')">取消</button>
          <button class="btn btn-sub" @click="examSave">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getExamList ,getModelAndSiteList ,saveExam ,getExamDetail ,delExam ,addAiExamSite} from "@/assets/js/api";
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
import myEditor from './../components/comment/wangeditor.vue'
import cityJson from './../assets/json/city.json'
export default {
  name: "index",
  data() {
    return {
      navId:'9',
      childrenID:'9-3',
      titleList:[
        {id:1,title:'试卷名称'},
        {id:2,title:'省市'},
        {id:3,title:'学段'},
        {id:4,title:'创建时间'},
        {id:5,title:'操作'},
      ],
      dataList:[],
      addType:'',
      removeType:false,
      token:'',
      obj:{
        page:1,
        rows:10
      },
      addObj:{},
      totalPage:0,
      removeID:'',
      url:'',
      educationList:[
        {id:1,title:'小学',value:'1'},
        {id:2,title:'初中',value:'2'},
        {id:3,title:'高中',value:'3'},
      ],
      typeList:[
        {id:1,title:'填空',value:'1'},
        {id:2,title:'选择',value:'2'},
      ],
      cityData:[],
      cityValue:[],
      topicThreeList:[],
      topicValue3:'',
      loading:false,
      loadTxt:'',
      uploadObj: {
        token: "",
        key: "",
      },
      dialogVisible:false,
      objCity:'',
      paperDetail:'',
      paperData:'',
      paperID:1,
      SiteList:[],
      examList:[],
      exam_sites:'',
      topicTypeList:[
        {id:1,title:'填空'},
        {id:2,title:'选择'},
      ],
      topicBox:false,
      topicID:'',
      topicItem:'',
      boxType:'',
      examType:false,
    };
  },
  components: {
    navBox,
    myHeader,
    myEditor
  },
  mounted(){
    var userData = JSON.parse(localStorage.getItem('userData'));
    this.token = userData.adminToken;
    this.url = this.$refs.navBox.url;
    this.getList();
    var list = [];
    cityJson.forEach(function(item,index){
      item.children.forEach(function(ele,num){
        delete ele.children;
      })
    })
    this.cityData = cityJson;
  },
  methods: {
    getToken(){
      var that = this;
      var url = this.$refs.navBox.url;
      axios({
        url: url+'/api/upload/getUploadToken',
        method:'post', 
      }).then((arr) => {
        if(arr.data.code == 200){
          that.uploadObj.token = arr.data.data.token
        } else {
          that.$message(arr.data.msg);
        }
      })
      .catch((error) => {
        console.log(error);
      });
    },
    handleChange(type) {
      var that = this;
      this.cityData.forEach(function(item,index){
        
        if(type == 'obj'){
          if(item.value == that.objCity[0]){
            that.obj.province = item.label;
          }
        } else {
          if(item.value == that.cityValue[0]){
            that.addObj.province = item.label;
          }
        }
        item.children.forEach(function(ele,num){
          
          if(type == 'obj'){
            if(ele.value == that.objCity[1]){
              that.obj.city = ele.label;
            }
          } else {
            if(ele.value == that.cityValue[1]){
              that.addObj.city = ele.label;
            }
          }
        })
      });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },

    async getList(){
      var that = this;
      try {
        const response = await getExamList(this.obj,this.token);
        if(response.code == 200){
          that.dataList = response.data.list;
          that.totalPage = response.data.total_page;  
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    topicType(i){
      var that = this;
      that.paperDetail = that.paperData[i].material;
      that.paperID = (i+1);
      that.paperDetail.forEach(function(item,index){
        item.topic.forEach(function(ele,num){
          if(!ele.exam_sites){
            ele.exam_sites = ['']
          }
        })
      })
    },

    async addSub(){
      var that = this;
      this.addType = 'add';
      try {
        const response = await getModelAndSiteList({type:2},this.token);
        if(response.code == 200){
          that.SiteList = response.data;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }

      try {
        const response = await getModelAndSiteList({type:1},this.token);
        if(response.code == 200){
          that.examList = response.data;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async buildShow(e){
      var that = this;

      try {
        const response = await getModelAndSiteList({type:2},this.token);
        if(response.code == 200){
          that.SiteList = response.data;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }

      try {
        const response = await getModelAndSiteList({type:1},this.token);
        if(response.code == 200){
          that.examList = response.data;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }

      try {
        const response = await getExamDetail({id:e.id},this.token);
        if(response.code == 200){
          that.cityValue = [];
          that.addType = 'edit';
          response.data.period = JSON.stringify(response.data.period)
          that.addObj = response.data;
          that.cityData.forEach(function(item,index){
            if(item.label == response.data.province){
              that.cityValue.push(item.value);
            }
            item.children.forEach(function(ele,num){
              if(ele.label == response.data.city){
                that.cityValue.push(ele.value);
              }
            })
          });
          that.paperData = response.data.sector;
          that.paperDetail = that.paperData[0].material;
          that.paperDetail.forEach(function(item,index){
            item.topic.forEach(function(ele,num){
              if(!ele.exam_sites){
                ele.exam_sites = ['']
              }
            })
          })
        that.paperID = 1;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
      
    },

    removeShow(e){
      this.removeID = e.id;
      this.removeType = true;
    },

    async removeSub(){
      var that = this;
      try {
        const response = await delExam({id:this.removeID},this.token);
        if(response.code == 200){
          that.$message('删除成功');
          that.getList();
          that.ModelHide('remove');       
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    ModelHide(type){
      var that = this;
      this.removeType = false;
      this.topicBox = false;
      this.examType = false;
      this.topicBox = false;
    },

    async saveSub(){
      var that = this;
      if(this.addObj.title == '' || !this.addObj.title){
        that.$message('请填写试卷名称！');
        return false;
      }
      if(this.addObj.province == '' || !this.addObj.province){
        that.$message('请选择省！');
        return false;
      }
      if(this.addObj.city == '' || !this.addObj.city){
        that.$message('请选择市！');
        return false;
      }
      if(this.addObj.period == ''|| !this.addObj.period){
        that.$message('请选择学段！');
        return false;
      }
      if(this.paperData == ''){
        that.$message('试卷内容为空！');
        return false;
      }
    
      // try {
      //     that.addObj.topic.forEach(function(item,index){
      //       if(item.topic == ''){
      //           that.$message('题目'+(index+1)+'题干还未填写');
      //           throw new Error("EndIterative");
      //       } 
      //       if(item.answer == ''){
      //           that.$message('题目'+(index+1)+'答案还未填写');
      //           throw new Error("EndIterative");
      //       } 
      //       if(item.topic_label_one == '' || item.topic_label_one == '生成中...'){
      //           that.$message('题目'+(index+1)+'题干一级标签还未填写');
      //           throw new Error("EndIterative");
      //       } 
      //     })
      // } catch(e) {
      //     if (e.message != "EndIterative") {
      //         throw e;
      //     } else {
      //         return // 如果跳出forEach循环的同时要终止下面的代码执行  则写这个  如果要继续执行下面的代码  则不需要return
      //     }
      // };
      this.addObj.sector = this.paperData;
      console.log(this.addObj)
      try {
        const response = await saveExam(this.addObj,this.token);
        if(response.code == 200){
          that.$message('成功');
          that.closeSub();
          that.getList();        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    closeSub(){
      this.addType='';
      this.addObj = {};
      this.cityValue = '';
      this.paperDetail = '';
      this.paperData='',
      this.paperID=1;
      this.SiteList=[];
      this.examList=[];
    },

    searchSub(){
      this.obj.page = 1;
      this.dataList = [];
      this.getList();
    },

    resetSub(){
      this.obj={
        page:1,
        rows:10,
      };
      this.addObj={};
      this.totalPage = 0;
      this.dataList = [];
      this.getList();
    },

    async aiSub(item,ele,k){
      var that = this;
      var obj = {
        content:item.content,
        topic:ele.topic_title
      }
      try {
        const response = await addAiExamSite(obj,this.token);
        if(response.code == 200){
            ele.exam_sites[k] = response.data.answer;
            console.log(ele.exam_sites);
            that.$forceUpdate();
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    siteChange(e){
      var that = this;
      console.log(e.exam_sites);
      this.$forceUpdate()
    },

    sourceClick(i){
      console.log(i,'==i==')
    },

    sourceInput(value,index) {
      // this.addObj.topics[index].content = value;
      console.log(value,'value')
    },

    imgUpload(type){
      console.log(type,'==type==')
    },

    imgShow(){
      this.imgType = true;
    },

    imgHide(){
      this.imgType = false;
    },

    imgRemove(){
      this.addObj.image = '';
    },

    beforeUploadImg(file) {
      this.loading = true;
      this.uploadObj.key = file.uid + file.name; // key为上传后文件名 必填
    },

    handleSuccessImg(response, file, fileList,index,type,num) {
      var that = this;
      // if(type == 'ph_headpic'){
      //   that.levelObj.level[index].ph_headpic = response.key;
      // } else if(type == 'user_banner'){
      //   that.examObj.level[index].image_videos[num].image = response.key;
      //   console.log(type,index,num,that.examObj.level,'==type==')
      //   // that.$forceUpdate();
      // } else {
      //   that.addObj.image = response.key;
      // }
      // that.loading = false;
      // that.uploadObj.key = "";
// var response = {
//         "code": 200,
//         "data": {
//             "sector": [
//                 {
//                     "model_id": 9,
//                     "title": "2023年长宁区初三二模语文试卷",
//                     "material": [
//                         {
//                             "mid": 13,
//                             "que_num": 1,
//                             "content": "fsdf",
//                             "topic": [
//                                 {
//                                     "tid": 47,
//                                     "que_num": 1,
//                                     "topic_type": 1,
//                                     "topic_title": "会当凌绝顶，    。（杜甫《望岳》）",
//                                     "topic_score": 1,
//                                     "option_A": "",
//                                     "option_B": "",
//                                     "option_C": "",
//                                     "option_D": "",
//                                     "answer": "一览众山小",
//                                     "exam_sites": [
//                                         "2"
//                                     ]
//                                 },
//                                 {
//                                     "tid": 48,
//                                     "que_num": 2,
//                                     "topic_type": 1,
//                                     "topic_title": "，赢得生前身后名。（辛弃疾《破阵子·为陈同甫赋壮词以寄之》）",
//                                     "topic_score": 2,
//                                     "option_A": "",
//                                     "option_B": "",
//                                     "option_C": "",
//                                     "option_D": "",
//                                     "answer": "了却君王天下事",
//                                     "exam_sites": [
//                                         "2"
//                                     ]
//                                 },
//                                 {
//                                     "tid": 49,
//                                     "que_num": 3,
//                                     "topic_type": 1,
//                                     "topic_title": "黄发垂髫，       。 （陶渊明《桃花源记》）",
//                                     "topic_score": 3,
//                                     "option_A": "",
//                                     "option_B": "",
//                                     "option_C": "",
//                                     "option_D": "",
//                                     "answer": "并怡然自乐",
//                                     "exam_sites": [
//                                         "2"
//                                     ]
//                                 },
//                                 {
//                                     "tid": 50,
//                                     "que_num": 4,
//                                     "topic_type": 1,
//                                     "topic_title": "对着一道难题苦思冥想许久也没有找到解决办法的小新，忽然茅塞顿开。欣喜的他脑海中浮现出陆游《游山西村》中的两句诗“     ，             。",
//                                     "topic_score": 4,
//                                     "option_A": "",
//                                     "option_B": "",
//                                     "option_C": "",
//                                     "option_D": "",
//                                     "answer": "山重水复疑无路，柳暗花明又一村#",
//                                     "exam_sites": [
//                                         ""
//                                     ]
//                                 }
//                             ]
//                         },
//                         {
//                             "mid": 14,
//                             "que_num": 2,
//                             "content": "【甲】咬定青山不放松，立根原在破岩中。千磨万击还坚劲，任尔东西南北风。【乙】水陆草木之花，可爱者甚蕃。晋陶渊明独爱菊。自李唐来，世人甚爱牡丹。予独爱莲之出淤泥而不染，濯清涟而不妖，中通外直，不蔓不枝，香远益清，亭亭净植，可远观而不可亵玩焉。予谓菊，花之隐逸者也；牡丹，花之富贵者也；莲，花之君子者也。噫！菊之爱，陶后鲜有闻。莲之爱，同予者何人？牡丹之爱，宜乎众矣。【丙】五台山有鸟，名寒号虫……当盛暑时，文采绚烂，乃自鸣曰：“凤凰不如我。”比至深冬严寒之际，毛羽脱落，索然如鷇雏①，遂自鸣曰:“得过且过。”嗟夫，世之人中无所守者，率②不甘湛涪③乡里，必振拔自豪，求尺寸名，诧九族侪类④，则便志满意得，出肆入扬，以为天下无复我加矣。及乎稍遇贬抑，遽若丧家之狗，垂首帖耳，摇尾乞怜，惟恐人不我恤。视寒号虫何异哉？ （选自《南村辍耕录》，有删减）【注释】：①鷇雏：待哺雏鸟。②率：大都。③湛涪：沉浮。④诧九族侪类：夸耀于亲族朋辈。",
//                             "topic": [
//                                 {
//                                     "tid": 51,
//                                     "que_num": 5,
//                                     "topic_type": 1,
//                                     "topic_title": "【甲】诗出自郑燮写的《       》，【乙】文出自     （人名）写的《爱莲说》。",
//                                     "topic_score": 2,
//                                     "option_A": "",
//                                     "option_B": "",
//                                     "option_C": "",
//                                     "option_D": "",
//                                     "answer": "竹石；周敦颐",
//                                     "exam_sites": [
//                                         "2"
//                                     ]
//                                 },
//                                 {
//                                     "tid": 52,
//                                     "que_num": 6,
//                                     "topic_type": 1,
//                                     "topic_title": "解释下列句中加点词。（1）比至深冬严寒之际（    ）；（2）遽若丧家之狗（    ） ",
//                                     "topic_score": 4,
//                                     "option_A": "",
//                                     "option_B": "",
//                                     "option_C": "",
//                                     "option_D": "",
//                                     "answer": "（1）到……时候/等到（2分）；（2）立即/立刻/马上/就（2分）",
//                                     "exam_sites": [
//                                         "2"
//                                     ]
//                                 },
//                                 {
//                                     "tid": 53,
//                                     "que_num": 7,
//                                     "topic_type": 1,
//                                     "topic_title": "用现代汉语翻译【乙】文中的画线句。莲之爱，同予者何人？",
//                                     "topic_score": 3,
//                                     "option_A": "",
//                                     "option_B": "",
//                                     "option_C": "",
//                                     "option_D": "",
//                                     "answer": "对于莲花的喜爱/喜爱莲花（1分），像我一样的还有什么人呢？（2分）",
//                                     "exam_sites": [
//                                         "2"
//                                     ]
//                                 },
//                                 {
//                                     "tid": 54,
//                                     "que_num": 8,
//                                     "topic_type": 1,
//                                     "topic_title": "根据【甲】【乙】【丙】三则诗文的内容，完成下表。|篇目|“物”的表现|人的品性|| ---- | ---- | ---- ||【甲】|咬定青山不放松|（1）_______||【乙】|“（2）      ，（3）         ” |洁身自好||【丙】|当羽毛色彩艳丽时，自鸣得意；（4）    。（用自己的话概括）|（5）________  意志薄弱|",
//                                     "topic_score": 8,
//                                     "option_A": "",
//                                     "option_B": "",
//                                     "option_C": "",
//                                     "option_D": "",
//                                     "answer": "（1）顽强/坚韧/坚贞/坚毅/坚定/坚忍/坚韧不拔（2分）；（2）出淤泥而不染/莲之出淤泥而不染（1分）；（3）濯清涟而不妖（1分）；（4）当羽毛脱落稀少时，灰心丧气/（自鸣）得过且过/垂头丧气（2分）；（5）骄傲自满/自以为是（2分）",
//                                     "exam_sites": [
//                                         "2"
//                                     ]
//                                 },
//                                 {
//                                     "tid": 55,
//                                     "que_num": 9,
//                                     "topic_type": 1,
//                                     "topic_title": "【甲】诗中的“竹”和【乙】文中的“莲”皆是有操守的君子形象，两位作者对此都表达了         之情；【丙】文中“无所守者”的具体表现是：（1）稍有成绩便忘乎所以；（2）           。（用自己的话概括）作者对这类人的态度是          。",
//                                     "topic_score": 5,
//                                     "option_A": "",
//                                     "option_B": "",
//                                     "option_C": "",
//                                     "option_D": "",
//                                     "answer": "喜爱/赞美/赞赏（1分）；稍遇挫折/贬抑 便摇尾乞怜/垂首帖耳/垂头丧气/毫无斗志/灰心丧气（2分）；嘲讽/讽刺/轻视/鄙弃（2分）",
//                                     "exam_sites": [
//                                         "2"
//                                     ]
//                                 }
//                             ]
//                         }
//                     ]
//                 },
//                 {
//                     "model_id": 10,
//                     "title": "洞庭天下水，岳阳天下楼",
//                     "material": []
//                 },
//                 {
//                     "model_id": 11,
//                     "title": "_______________________",
//                     "material": [
//                         {
//                             "mid": 15,
//                             "que_num": 1,
//                             "content": "班级组织了“优秀笔记”评选活动，各小组需要合作完成“名著阅读”的复习笔记。【案例1】“云帆”小组用表格梳理了名著阅读书目的基本信息。|书名|作者|内容简介|| ---- | ---- | ---- ||A:《骆驼祥子》|D:鲁迅|G:小说描写了一个普通人力车夫的一生，展示了一幅具有老北京风情的世态图。||B:《儒林外史》|E:吴敬梓|H:散文集展现了普通士人的日常生活状态与精神世界。||C:《海底两万里》|F：儒勒·凡尔纳|I:小说设想了潜水艇的强大功能，描绘了奇幻美妙的海底世界。|",
//                             "topic": [
//                                 {
//                                     "tid": 56,
//                                     "que_num": 10,
//                                     "topic_type": 1,
//                                     "topic_title": "表格中有两处错误，请指出并加以修改。错误一：   （填字母）修改为：_________错误二：   （填字母）修改为：_________",
//                                     "topic_score": 4,
//                                     "option_A": "",
//                                     "option_B": "",
//                                     "option_C": "",
//                                     "option_D": "",
//                                     "answer": "错误一：D（1分）修改：老舍（舒庆春）（1分）；错误二：H（1分）修改：小说/小说展现了一个个普通士人的日常生活状态与精神世界。（1分）",
//                                     "exam_sites": [
//                                         "2"
//                                     ]
//                                 },
//                                 {
//                                     "tid": 57,
//                                     "que_num": 11,
//                                     "topic_type": 2,
//                                     "topic_title": "下列选项中哪一项最不适宜填入表格【J】处（）",
//                                     "topic_score": 3,
//                                     "option_A": "作品价值    ",
//                                     "option_B": "道理启示   ",
//                                     "option_C": "出版信息     ",
//                                     "option_D": "人物形象\n",
//                                     "answer": "C（3分）【案例2】“海燕”小组用思维导图梳理了《鲁滨逊漂流记》的部分内容。",
//                                     "exam_sites": [
//                                         "2"
//                                     ]
//                                 },
//                                 {
//                                     "tid": 58,
//                                     "que_num": 12,
//                                     "topic_type": 2,
//                                     "topic_title": "最适合作为该思维导图的主题填入甲处的选项是（   ）",
//                                     "topic_score": 3,
//                                     "option_A": "改造“星期五”",
//                                     "option_B": "鲁滨逊的冒险精神    ",
//                                     "option_C": "“星期五”的蜕变",
//                                     "option_D": "岛上的生活\n",
//                                     "answer": "A（3分）",
//                                     "exam_sites": [
//                                         "2"
//                                     ]
//                                 },
//                                 {
//                                     "tid": 59,
//                                     "que_num": 13,
//                                     "topic_type": 1,
//                                     "topic_title": "请根据思维导图的内容，在乙处填入合适的词语。      ",
//                                     "topic_score": 3,
//                                     "option_A": "",
//                                     "option_B": "",
//                                     "option_C": "",
//                                     "option_D": "",
//                                     "answer": "劳作/劳动【案例3】“远航”小组对相关书目在主题或内容上的相同点进行了归纳。",
//                                     "exam_sites": [
//                                         "2"
//                                     ]
//                                 },
//                                 {
//                                     "tid": 60,
//                                     "que_num": 14,
//                                     "topic_type": 1,
//                                     "topic_title": "请选择其中一组，围绕相同点，结合书中的相关内容加以说明。（100字左右）",
//                                     "topic_score": 7,
//                                     "option_A": "",
//                                     "option_B": "",
//                                     "option_C": "",
//                                     "option_D": "",
//                                     "answer": "示例1：选A组。简·爱在童年时对抗骄横、恶毒的表哥，长大后又因捍卫人格而放弃自己已有的“饭碗”，这些行为无不体现了她独立而勇敢的一面。鲁滨逊流落荒岛，克服了缺乏基本生存条件等常人无法想象的困难，体现了他坚毅勇敢的一面。示例2：选B组。怀揣梦想的祥子一生，三起三落，千辛万苦买来的洋车屡次被“夺”，让他燃起的希望一次又一次破灭。作为革命者的保尔身受重伤，后又重病缠身，失去了战斗能力，甚至一度让他失去了对生活的希望。",
//                                     "exam_sites": [
//                                         "2"
//                                     ]
//                                 }
//                             ]
//                         },
//                         {
//                             "mid": 16,
//                             "que_num": 2,
//                             "content": "",
//                             "topic": [
//                                 {
//                                     "tid": 61,
//                                     "que_num": 15,
//                                     "topic_type": 1,
//                                     "topic_title": "请以“身边”为题，写一篇不少于600字的文章。 要求：（1）不得透露个人相关信息。（2）不得抄袭。",
//                                     "topic_score": 0,
//                                     "option_A": "",
//                                     "option_B": "",
//                                     "option_C": "",
//                                     "option_D": "",
//                                     "answer": "无（写作题无固定答案）",
//                                     "exam_sites": [
//                                         "2"
//                                     ]
//                                 }
//                             ]
//                         }
//                     ]
//                 }
//             ]
//         },
//         "msg": "",
//         "time": 1755160201
//     }
//       console.log(response,'data');
      if(response.code == 200){
        that.paperData = response.data.sector;
        that.paperDetail = that.paperData[0].material;
        that.paperDetail.forEach(function(item,index){
          item.topic.forEach(function(ele,num){
            if(!ele.exam_sites){
              ele.exam_sites = ['']
            }
          })
        })
        that.paperID = 1;
        that.loading = false;
        that.loadTxt = '';
      } else {
        that.$message(response.msg);
        that.loading = false;
        that.loadTxt = '';
      }
    },

    handleProgressImg(event, file, fileList) {
      // this.loadTxt = "已上传" + file.percentage.toFixed(0) + "%";
      this.loadTxt = "解析文档需要几分钟，请稍等......";
    },

    handleRemoveImg() {
      this.uploadUrl = "";
      this.addObj.image = "";
    },

    examSitesAdd(e){
      e.exam_sites.push('');
      this.$forceUpdate();
    },

    examRemove(e,i){
      e.exam_sites.splice(i,1);
      this.$forceUpdate();
    },

    topicAdd(i,type,item){
      this.topicID = '';
      this.topicBox = true;
      this.boxType = type;
      if(type == 'score'){
        this.topicItem = item;
      }
    },

    topicRemove(index){
      this.paperDetail.splice(index,1);
    },

    topicTypeSub(){
      var that = this;
      if(this.boxType == 'score'){
        this.scoreAdd();
        return false;
      }
      var length1 = parseInt(this.paperDetail.length-1);
      var length2 = parseInt(this.paperDetail[length1].topic.length-1);
      var list = {};
      if(that.topicID == 1){
        list = {
          content:'',
          que_num:(this.paperDetail[this.paperDetail.length-1].que_num + 1),
          topic:[
            {
              answer: "",
              exam_sites: [''],
              que_num: parseInt(that.paperDetail[length1].topic[length2].que_num+1),
              topic_score: 0,
              topic_title: "",
              topic_type: 1
            }
          ]
        }
      } else {
        list = {
          content:'',
          que_num:(this.paperDetail[this.paperDetail.length-1].que_num + 1),
          topic:[
            {
              answer: "",
              exam_sites: [''],
              option_A:'',
              option_B:'',
              option_C:'',
              option_D:'',
              que_num: parseInt(that.paperDetail[length1].topic[length2].que_num+1),
              topic_score: 0,
              topic_title: "",
              topic_type: 2
            }
          ]
        }
      }
      this.topicBox = false;
      this.paperDetail.push(list);
    },

    scoreAdd(){
      var that = this;
      console.log(this.topicItem,this.paperDetail);
      var list = [];
      if(that.topicID == 1){
        list = {
          answer: "",
          exam_sites: [''],
          que_num: '',
          topic_score: 0,
          topic_title: "",
          topic_type: 1
        }
      } else {
        list = {
          answer: "",
          exam_sites: [''],
          option_A:'',
          option_B:'',
          option_C:'',
          option_D:'',
          que_num: '',
          topic_score: 0,
          topic_title: "",
          topic_type: 2
        }
      }
      this.topicBox = false;
      this.topicItem.topic.push(list);
    },

    scoreRemove(e,n){
      e.topic.splice(n,1);
    },

    examChange(){
      this.examType = true;
    },

    examAdd(){
      console.log(this.paperData)
      var list = {
        "title": "",
        "material": [
            {
                "que_num": 1,
                "content": "",
                "topic": [
                    {
                        "que_num": "",
                        "topic_type": 1,
                        "topic_score": 0,
                        "topic_title": "",
                        "answer": ""
                    },
                ]
            },
          ]
      };
      this.paperData.push(list);
    },

    examDel(index){
      this.paperData.splice(index,1);
    },

    examSave(){
      this.examType = false;
      this.paperID = 1;
      this.$forceUpdate();
    },

    examRevise(index){
      // this.paperData[index].material = [
      //   {
      //     "que_num": 1,
      //     "content": "",
      //     "topic": [
      //         {
      //             "que_num": "",
      //             "topic_type": 1,
      //             "topic_score": 0,
      //             "topic_title": "",
      //         "answer": ""
      //         },
      //     ]
      //   }
      // ];
      // if(parseInt(index+1) == this.paperID){
      //   this.paperDetail = this.paperData[index].material;
      // }
      // this.$forceUpdate();
    }
  }

  
};
</script>
<style scoped>
  .dataList .listItem p,  
  .organiza-list p{
    width: calc( 100% / 5 );
    white-space: nowrap; /* 禁止文本换行 */
    overflow: hidden; /* 隐藏超出范围的内容 */
    text-overflow: ellipsis; /* 使用省略号 */
    padding: 21px 5px;
  }

  .add-title,
  .list-title{
    color: #333333;
    font-size: 22px;
    display: block;
    margin-bottom: 20px;
    position: relative;
    padding-left: 20px;
    line-height: 40px;
  }

  .add-title::before,
  .list-title::before{
    content: '';
    width: 5px;
    height: 22px;
    background-color: #6098F2;
    position: absolute;
    top: 50%;
    transform: translate(0,-50%);
    left: 5px;
  }

  .add-title .btn-topic-remove{
    background-color: #E2231A;
    border-radius: 6px;
    color: #fff;
    font-size: 16px;
    padding: 5px 20px;
    box-sizing: border-box;
    margin-left: 30px;
    font-weight: 100;
  }

  .btn-topic-adds{
    font-size: 18px;
    float: right;
  }

  .MobelBox{
    padding: 40px;
    box-sizing: border-box;
    width: 100%;
  }

  .MobelBox .write-txt{
    display: block;
    width: 100%;
    margin-bottom: 20px;
  }

  .MobelBox .write-text{
    display: inline-block;
    vertical-align: top;
    width: 80%;
    margin-left: 20px;
  }

  .MobelBox .write-text span{
    font-size: 14px;
    color: #E2231A;
    margin-top: 10px;
    display: block;
  }

  .MobelBox input,
  .MobelBox textarea{
    width: 80%;
    height: 334px;
    background-color: #FFFFFF;
    border-radius: 6px;
    display: block;
    padding: 20px;
    box-sizing: border-box;
    border: solid 1px #333333;
    font-size: 16px;
  }

  .MobelBox input{
    height: 50px;
    line-height: 50px;
    width: 500px;
  }

  .MobelBox>>> .el-input{
    font-size: 16px;
  }

  .msgBox .contv{
    padding: 40px 73px;
    border-radius: 32px;
  }

  .msgBox .title {
    text-align: center;
    margin-bottom: 50px;
  }

  .btn-exam-remove,
  .btn-ai{
    background-color: #6098F2;
    border-radius: 6px;
    color: #fff;
    font-size: 16px;
    color: #fff;
    box-sizing: border-box;
    padding: 0px 20px;
    height: 39px;
    line-height: 39px;
    display: inline-block;
    margin-left: 20px;
  }

  
  .btn-exam-remove{
    background-color: #F26060;
  }

  .ai-msg{
    height: 50px;
    line-height: 50px;
    color: #777777;
    font-size: 14px;
    display: inline-block;
    margin-left: 18px;
  }

  .MobelBox .write-ai .write-text{
    width: auto;
  }

  .organiza-txt>>>.el-upload{
    width: 100%;
    display: block;
  }

  .organiza-txt>>>.el-button--small span{
    width: 100%;
    text-align: center;
    display: block;
    }

  .organiza-txt>>>.el-button--primary{
    background-color: transparent;
    border: none;
    font-size: 15px;
  }

  .btn-topic-add{
    font-size: 18px;
    color: #6098F2;
    margin: 30px 0 20px;
    display: block;  
    border: solid 1px #6098F2;
    border-radius: 6px;
    padding: 3px 30px;
    box-sizing: border-box;
  }

  .model-cont{
    background-color: #fff;
    display: block;
    box-sizing: border-box;
    padding: 30px;
    border-radius: 6px;
    margin-bottom: 10px;
  }

  .MobelBox .model-cont .btn-hide{
    margin: 0 0 10px;
  }

  .model-cont .ai-msg{
    font-size: 12px;
    color: #999999;
  }

  .model-cont .msg-txt{
    background-color: #FFF0F0;
    border-radius: 6px;
    font-size: 12px;
    color: #333333;
    display: inline-block;
    vertical-align: top;
    padding: 11px 20px;
    box-sizing: border-box;
    margin-left: 10px;
  }

  .model-item .icon-msg,
  .model-cont .icon-msg{
    background-image: url(~@/assets/images/icon-msg.png);
    width: 16px;
    height: 16px;
    background-size: 16px 16px;
    display: inline-block;
    vertical-align: middle;
  }

  .model-cont .add-title{
    font-size: 18px;
    font-weight: bold;
  }

  .step-cont{
    display: block;
  }

  .step-list{
    font-size: 0;
    display: block;
    text-align: center;
  }

  .step-list .step-item{
    display: inline-block;
    vertical-align: top;
    text-align: center;
    position: relative;
    margin-right: 150px;
  }

  .step-list .step-item.select p{
    border-color: #6098F2;
    background-color: #6098F2;
    color: #fff;
  }

  .step-list .step-item p{
    width: 60px;
    height: 60px;
    line-height: 60px;
    border-radius: 100%;
    border: solid 2px #777777;
    font-size: 28px;
    color: #777777;
    display: block;
    margin: 0 auto .05rem;
  }

  .step-list .step-item.select span{
    color: #6098F2;
  }

  .step-list .step-item span{
    color: #777777;
    font-size: 18px;
    display: block;
    margin-top: 6px;
  }

  .step-list .step-item .line{
    width: 150px;
    height: 2px;
    background-color: #777777;
    position: absolute;
    top: 29px;
    right: -150px;
  }

  .info-title{
    font-size: 20px;
    color: #333333;
    display: block;
    margin: 20px 0;
    font-weight: bold;
  }

  .table-cont{
    display: block;
    width: 80%;
    float: right;
    text-align: center;
  }

  .table-list .table-item,
  .table-cont .table-title{
    font-size: 0;
  }

  .table-list .table-item p,
  .table-cont .table-title p{
    width: 25%;
    font-size: 18px;
    color: #333333;
    font-weight: bold;
    padding: 20px 10px;
    box-sizing: border-box;
    background-color: #F0F4FB;
    display: inline-block;
    vertical-align: top;
  }

  .table-list .table-item p{
    background-color: #fff;
  }

  .wrong-cont .write-title,
  .wrong-cont .add-title{
    display: inline-block;
    vertical-align: top;
  }

  .wrong-cont .write-title{
    line-height: 40px;
    margin-left: 24px;
  }

  .wrong-cause{
    font-size: 0;
  }

  .wrong-title{
    font-size: 18px;
    color: #333333;
    float: left;
    line-height: 40px;
  }

  .wrong-cause .btn-wrong{
    line-height: 40px;
    color: #6098F2;
    border-radius: 6px;
    border: solid 1px #6098F2;
    float: right;
    font-size: 16px;
    box-sizing: border-box;
    padding: 0 25px;
  }

  .wrong-cause .wrong-txt{
    background-color: #EDEDED;
    border-radius: 6px;
    font-size: 14px;
    color: #333333;
    box-sizing: border-box;
    padding: 20px;
    margin-top: 10px;
  }

  .tager-list .write-score{
    margin-left: 50px;
  }

  .tager-list .write-score .write-text{
    font-size: 18px;
    color: #333333;
  }

  .tager-list .write-score .write-text input{
    display: inline-block;
    margin: 0 10px;
  }

  .score-cont .btn-score{
    font-size: 18px;
    color: #6098F2;
    box-sizing: border-box;
    padding: 6px 24px;
    border-radius: 6px;
    border: solid 1px #6098F2;
    display: block;
    margin-top: 30px;
  }

  .plan-cont .info-title span{
    font-size: 24px;
    color: #54EF07;
    margin-left: 25px;
  }

  .plan-cont .add-title span{
    font-size: 18px;
    color: #54EF07;
    margin-left: 35px;
  }

  .model-item .msg-txt{
    background-color: #FFF0F0;
    border-radius: 6px;
    box-sizing: border-box;
    padding: 10px 20px;
    margin-top: 30px;
    display: block;
  }

  .model-item .msg-txt p{
    font-size: 12px;
    color: #333333;
    line-height: 24px;
  }

  .model-item .msg-txt p span{
    color: #6098F2;
  }

  .write-text .relative{
    border: none;
  }

  .write-text .editor-cont{
    display: block;
  }

  .model-cont .topic-data{
    margin-bottom: 20px;
  }

  .paper-title{
    font-size: 0;
    text-align: center;
    margin: 70px 0 20px;
  }

  .paper-title p{
    display: inline-block;
    vertical-align: top;
    color: #777777;
    font-size: 24px;
    margin-right: 40px;
    padding: 0 0 10px 0;
    box-sizing: border-box;
  }

  .paper-title p.select{
    color: #6098F2;
    font-size: 26px;
    border-bottom: solid 4px #6098F2;
  }

  .topicAddBox .msg-write{
    margin-bottom: 50px;
  }

  .topicAddBox .msg-title{
    font-size: 18px;
    color: #333;
    display: inline-block;
    vertical-align: top;
    line-height: 40px;
  }

  .examBox>>> .el-select{
    width: 300px;
  }
</style>



// WEBPACK FOOTER //
// src/study/paper.vue